module.exports = __webpack_public_path__ + "static/media/answer_img1.bf256ccd.png";